// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
// import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyB7PysO7DbA4Ppwdr_AXm_mQhEcf3vv3qQ",
  authDomain: "lets-79ce8.firebaseapp.com",
  projectId: "lets-79ce8",
  storageBucket: "lets-79ce8.firebasestorage.app",
  messagingSenderId: "85267317983",
  appId: "1:85267317983:web:5a290027014f11e4d1556a"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
// ✅ Firestore
// export const db = getFirestore(app);